import React from "react";
import ProfilePic from "components/General/ProfilePic";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import TextTheme from "components/General/Text/TextTheme";
import * as CONSTANT from "constants/text";
import SendIcon from "@material-ui/icons/Send";
import TextArea from "../../../../General/Form/TextArea";

class NewsfeedCommentField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      comment: "",
    };
    //function binding declarations
    this.onPostClick = this.onPostClick.bind(this);
    this.onCommentFieldChange = this.onCommentFieldChange.bind(this);
  }

  onCommentFieldChange(e) {
    this.setState({ comment: e.target.value });
  }

  onPostClick() {
    /*handle post*/
    this.props.postButtonClick(
      this.state.comment,
      this.props.username,
      this.props.profilePic
    );
    /*clear out comment field*/
    this.setState({ comment: "" });
  }

  render() {
    return (
      <div className="comment_column_field">
        <div className="profile_pic_write">
          <ProfilePic
            profilePic={this.props.profilePic}
            className="post_profile_pic"
          />
        </div>
        <div className="comment_message_field">
          <TextTheme
            message={this.props.username}
            className="text_semi_bold text_small"
          />
          <div className="text_field add_post_text_field">            
            <TextArea
              name="write_comment"
              placeholder={CONSTANT.WRITE_COMMENT}
              value={this.state.comment}
              handleChange={this.onCommentFieldChange}
              rows="1"
              cols="1"
            />
            <div className="post_button">
              <RoundedButton
                startIcon={
                  <SendIcon style={{ fontSize: 20, color: "white" }} />
                }
                title={CONSTANT.POST}
                handleOnClick={this.onPostClick}
                textThemeClassName="text_small text_bold text_white"
                buttonClassName="background_dark_orange"
                float="none"
                borderRadius="6px"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NewsfeedCommentField;
